import {
  GET_WASTABLE_ITEMS,
  GET_WASTE_DATA,
  LOAD_MORE_WASTE_DATA
} from "../types";
import axios from "axios";
import {firebase} from '../../../firebase/initFirebase'
import moment from 'moment'
import {store} from '../../store'
import { message} from 'antd';
import S3 from 'react-aws-s3';



export const getWastableData = (props) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var userRole = reduxState.auth.user.role
    var useremail = reduxState.auth.user.email   
    var userLocation = reduxState.auth.user.branch
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection('wastes') 
    var userLocationName = reduxState.auth.user.branch_name

      // console.log(props)
    
      dataRef = dataRef.orderBy("created_at","desc")
 
      dataRef = dataRef.where("status", "==", "completed")        
       
      

      if(userRole !== 'admin' && userRole !== 'manager'){
        dataRef = dataRef.where("branch", "==", userLocation)   
      }

 
      // if(props.searchText){
      //   dataRef = dataRef.orderBy('name').startAt(props.searchText).endAt(props.searchText + '\uf8ff')
      // }
      // if(props.filters){
      //   if(props.filters.length > 0){
      //     props.filters.map(item=>{
      //       console.log(item)
      //       dataRef = dataRef.orderBy(item.dataIndex).startAt(item.value).endAt(item.value + '\uf8ff')
      //     })
      //   }       
      // }

      dataRef = dataRef.limit(40)
    
      var documentSnapshots = await dataRef.get()
      var docs = documentSnapshots.docs
      var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length-1];
      var dataArray =[]

      await Promise.all(docs.map(async (salesItem) => {    
        var newOrder={
            key:salesItem.id,
            id:salesItem.id,
            ...salesItem.data()
        }

   

        dataArray.push(newOrder)
      }));
      dispatch({ type: GET_WASTE_DATA, payload: {dataArray:dataArray, lastVisible:lastVisible, currentProps:props } }) 

      
  };
};

export const loadMoreWastableData = () => {
  return async(dispatch) => {
    var reduxState = store.getState()
    var userRole = reduxState.auth.user.role
    var useremail = reduxState.auth.user.email
    var currentLastItem = reduxState.dailysales.lastVisible
    var userLocation = reduxState.auth.user.branch
    var currentProps = reduxState.dailysales.currentProps
    var Firestore = firebase.firestore();
    var userLocationName = reduxState.auth.user.branch_name
    
    var dataRef = Firestore.collection(currentProps.apiurl) 

      dataRef = dataRef.orderBy("created_at","desc") 
          
      dataRef = dataRef.where("status", "==", "completed")    
    
      if(userRole !== 'admin' && userRole !== 'manager'){
        dataRef = dataRef.where("branch", "==", userLocation)   

      }

      if(currentLastItem){
        dataRef = dataRef.startAfter(currentLastItem)
              
      
        // if(currentProps.searchText){
        //   dataRef = dataRef.where('name', '>=', currentProps.searchText).where('name', '<=', currentProps.searchText+ '\uf8ff')
        // }

        dataRef = dataRef.limit(100)
 
        var documentSnapshots = await dataRef.get()
        var docs = documentSnapshots.docs
        if(docs){
          var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length-1];
          var dataArray =[]
          await Promise.all(docs.map(async (salesItem) => {    
            var newOrder={
                key:salesItem.id,
                id:salesItem.id,
                ...salesItem.data()
            }
  
     
            dataArray.push(newOrder)
          }));
          if(lastVisible && currentLastItem !== lastVisible){

            dispatch({ type: LOAD_MORE_WASTE_DATA, payload: {dataArray:dataArray, lastVisible:lastVisible} })  
          }else{
            message.error('No More Orders To Load');
          }
        }else{
          message.error('No More Orders To Load');
        }
    }
  };
};





export const getWastableItems = (props) => {
  return async(dispatch) => {
    var reduxState = store.getState()
    var userRole = reduxState.auth.user.role
    var useremail = reduxState.auth.user.email   
    var userLocation = reduxState.auth.user.branch
    var Firestore = firebase.firestore();
    var productdataRef = Firestore.collection('products')
      // console.log(props)
      productdataRef = productdataRef.orderBy("category_name","desc")

      productdataRef = productdataRef.where("is_wastable", "==", true)
      productdataRef = productdataRef.where("hq_only", "==", false)  

      var varname = `${userLocation}_count`
     
      var documentSnapshots = await productdataRef.get()
    
      var proddocs = documentSnapshots.docs
      var newProds = []
   
      await Promise.all(proddocs.map(async (item) => {  
              
        var prodingredientsRef = Firestore.collection('products').doc(item.id).collection('ingredients') 
        var ingredientsdocs = await prodingredientsRef.get()
        var newinds =[]
        if(ingredientsdocs.docs){         
          ingredientsdocs.docs.map(ind =>{
            if(ind.data()?.product){
              newinds.push(ind.data())
            }     
          })                 
        }
        var newProd={
          key:item.id,
          id:item.id,
          ingredients: newinds,
          ...item.data()
        } 
        if(newProd?.[varname] !== undefined){
          newProds.push(newProd)
        }

      }))
      dispatch({ type: GET_WASTABLE_ITEMS, payload:newProds }) 
 
  };
};



export const setWastable = (wasted_items,createDate) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id
    var userName = reduxState.auth.user.name
    var userLocation = reduxState.auth.user.branch
    var userLocationName = reduxState.auth.user.branch_name


    var wasteRef = Firestore.collection('wastes').doc()

    var exchangerateRef = Firestore.collection('config').doc('weightedexchangerate')
    var exchangerateSnapshot = await exchangerateRef.get()

    var exchangeitem = exchangerateSnapshot.data().value

  
    var salesData = { 
      status: 'completed',
      created_at: createDate.format('YYYY-MM-DD HH:mm:ss'),      
      created_by:userID,
      created_name:userName, 
      branch:userLocation,
      branch_name:userLocationName,
      wasted_items: wasted_items,
      exchange_rate: exchangeitem
    }
    console.log(salesData)

    var salesndone = await wasteRef.set(salesData,{merge: true})

    return('oks')
  };
};


export const setWastableExrate= (wasteditems) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id
    var userName = reduxState.auth.user.name
    var userLocation = reduxState.auth.user.branch
    var userLocationName = reduxState.auth.user.branch_name

    for (let i = 0; i < wasteditems.length; i++) {
      var currentWaste = wasteditems[i]
      console.log(currentWaste)
      var wasteRef = Firestore.collection('wastes').doc(currentWaste.id)
      var salesData = { 
        exchange_rate: 8.4
      }
      var salesndone = await wasteRef.set(salesData,{merge: true})
      console.log(i+1 ,"/",  wasteditems.length)
    }
 

    return('oks')
  };
};


export const voidWastedItems = (record) => {
  return async (dispatch) => {
    var reduxState = store.getState()
    var Firestore = firebase.firestore();
    var userID = reduxState.auth.user.id
    var userName = reduxState.auth.user.name
    var userLocation = reduxState.auth.user.branch
    var userLocationName = reduxState.auth.user.branch_name


    var salesRef = Firestore.collection('wastes').doc(record.id)
 

    var salesData = { 
      status: 'voided',
      voided_at: moment().format('YYYY-MM-DD HH:mm:ss'),            
      voided_by:userID,
      voided_name:userName, 
    }
    console.log(salesData)

    var salesndone = await salesRef.set(salesData,{merge: true})

    return('oks')
  };
};
